import type { TFunction } from 'i18next';

import type { SetupConnectTutorialStep } from '@/components/setup/experience/lib/connectTutorialTypes';
import { brandingConfig } from '@/config/branding';

export type WooConnectTutorialMode = 'oauth' | 'manual';

const WOO_OAUTH_STEP_IDS = ['permalinks', 'ssl', 'shop-url', 'authorize', 'return'] as const;
const WOO_MANUAL_STEP_IDS = [
  'rest-api',
  'create-key',
  'permissions',
  'copy-keys',
  'paste-form',
  'verify',
] as const;

export function getSetupWooConnectTutorialSteps(
  t: TFunction<'setup'>,
  mode: WooConnectTutorialMode,
): SetupConnectTutorialStep[] {
  const prefix =
    mode === 'oauth' ? 'experience.connect.wooTutorial.oauth' : 'experience.connect.wooTutorial.manual';

  const ids = mode === 'oauth' ? WOO_OAUTH_STEP_IDS : WOO_MANUAL_STEP_IDS;

  return ids.map((id) => ({
    id: `woo-${mode}-${id}`,
    title: t(`${prefix}.steps.${id}.title`),
    instructions: t(`${prefix}.steps.${id}.instructions`, {
      appName: brandingConfig.appName,
    }),
  }));
}
